import React, { useContext } from "react";
import { Badge, Text, Link, ResourceItem, InlineStack } from "@shopify/polaris";
import { BillFilledIcon } from "@shopify/polaris-icons";

// import helpers
import { baseHelper } from "lib/helpers";

// import constant
import constant from "lib/constant/constant";

// import context
import { PrivateContext } from "lib/context";

// import props
import Popover from "lib/components/popover/popover";
import { rowProp } from "app/paymentsLake/modules/generic/list/propTypes";

// import cms and subFeature
import actionData from "app/paymentsLake/modules/generic/list/cms/payment";
import { useNavigate } from "react-router-dom";

const topMargin10px = {
  marginTop: "10px",
};

function PaymentRow(props) {
  const { cms } = useContext(PrivateContext);
  const navigate = useNavigate();
  const { activePopover, item, setActivePopover, isInvoiceEnabled = true } = props;
  const { _id: id, orderId } = item;
  const { mainLink } = actionData(cms);
  const { COMPLETE, PAY_AND_COLLECT, RESERVE, SHIPPED } = constant;

  const renderOrderRow = (items) => {
    const {
      _id,
      accountingStatus,
      commissionSeller,
      commissionVendor,
      createdAt,
      fulfillmentType,
      isAutoExpiry,
      isAutoReject,
      isRefund,
      name,
      dueDate,
      storeOrderId,
      storeStatus,
      shippingStatus,
      vendor,
    } = items;

    let { status } = items;

    const isReserve = status === SHIPPED && fulfillmentType === RESERVE;
    if (isReserve) {
      status = PAY_AND_COLLECT;
    }

    const autoStatus = isRefund && isAutoReject ? constant.AUTO_REJECT : isAutoExpiry && constant.NO_SHOW;
    status = autoStatus || status;

    const accountingBadgeStatus = baseHelper.ucFirst(accountingStatus);
    const accountingBadgeType = baseHelper.getBadgeType(accountingStatus);

    const handleClick = () => {
      navigate(`${mainLink.orderNumber}${orderId}`);
    };

    const orderStatus =
      (shippingStatus === constant.DISPATCHED && constant.COMPLETE) ||
      (shippingStatus === constant.AWAITING_DISPATCH && constant.PROCESS) ||
      storeStatus;

    const badgeStatus = baseHelper.ucFirst(orderStatus);
    const badgeType = baseHelper.getBadgeType(orderStatus);
    const isInvoiceViewAllowed = [SHIPPED, COMPLETE].includes(orderStatus.toLowerCase());

    return (
      <>
        <InlineStack blockAlign="start">
          <div>
            <Text as="span">
              <Link onClick={handleClick}>
                {"#"}
                {storeOrderId}
              </Link>
            </Text>
            <Text variant="bodySm" as="p">
              <Text as="span" fontWeight="semibold">
                <div className="wrapbox loose">{`Name: ${name}`}</div>
              </Text>
              <br />
              <Text as="span">
                {` ${cms("label.commission")}: ${vendor[0].moneyFormat} ${baseHelper.getPrice(commissionSeller)}`}
              </Text>
              <br />
              <Text as="span">
                {` ${cms("label.amount")}: ${vendor[0].moneyFormat} ${baseHelper.getPrice(commissionVendor)}`}
              </Text>
              <br />
              <Text as="span" tone="subdued">
                {`${cms("label.creationDate")}: ${baseHelper.formatDate(createdAt, true)}`}
              </Text>
              <br />
              {dueDate && <Text as="span">{`${cms("label.dueDate")}: ${baseHelper.formatDate(dueDate)}`}</Text>}
            </Text>
          </div>
          {isInvoiceEnabled && (
            <Popover
              // eslint-disable-next-line no-underscore-dangle
              active={activePopover[_id]}
              // eslint-disable-next-line no-underscore-dangle
              setActive={() => setActivePopover({ [_id]: !activePopover[_id] })}
              options={[
                {
                  content: cms("label.invoice"),
                  icon: BillFilledIcon,
                  onAction: () => window.open(`/payment-lake/invoice/${orderId}`, "_blank"),
                  disabled: !isInvoiceViewAllowed,
                },
              ]}
            />
          )}
        </InlineStack>
        <div style={topMargin10px}>
          <br />
          <div>
            <InlineStack>
              <Badge status={badgeType}>{badgeStatus}</Badge>
              <Badge status={accountingBadgeType}>{accountingBadgeStatus}</Badge>
            </InlineStack>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <ResourceItem id={id}>
        <InlineStack align="space-evenly">{renderOrderRow(item)}</InlineStack>
      </ResourceItem>
    </>
  );
}

PaymentRow.propTypes = rowProp.type;
export default PaymentRow;
